import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	createScheduleErrorTitle: {
		id: 'eoc-schedule.controllers.section.create-schedule-error-title',
		defaultMessage: "We couldn't create your schedule.",
		description:
			'This message indicates that our back-end services did not respond when creating schedule.',
	},
	createScheduleSuccessTitle: {
		id: 'eoc-schedule.controllers.section.create-schedule-error-title',
		defaultMessage: "You've added a new schedule.",
		description: 'This message indicates schedule is successfully created.',
	},
	cloneScheduleErrorTitle: {
		id: 'eoc-schedule.controllers.section.clone-schedule-error-title',
		defaultMessage: "We couldn't duplicated your schedule.",
		description:
			'This message indicates that our back-end services did not respond when duplicating schedule.',
	},
	cloneScheduleSuccessTitle: {
		id: 'eoc-schedule.controllers.section.clone-schedule-success-title',
		defaultMessage: "You've duplicated the schedule.",
		description: 'This message indicates schedule is successfully duplicated.',
	},
});
